<template>
    <div class="flex flex-col font-light xl:font-hairline">
        <div class="flex my-8 pl-2">
            <h1 class="ml-1 text-4xl font-hairline rotate">Lépj</h1>
            <div class="-ml-8">
                <h2 class="text-4xl font-normal uppercase ml-2">kapcsolatba</h2>
                <h2 class="ml-8 -mt-1 text-4xl font-hairline">velünk <span
                        class="font-normal">bármikor</span></h2>
            </div>
        </div>
        <div class="text-justify p-4 tracking-normal flex flex-col text-sm md:text-base">
            <p class="md:my-8 leading-normal">Keress minket az alábbi elérhetőségeinken, vagy hagyj
                üzenetet percek alatt a form
                kitöltésével. Az üzenet beérkezését követő 24 órán belül választ kapsz tőlünk!
            </p>
            <div class="mt-4 flex justify-start items-center">
                <svg class="w-6 h-6 p-px svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.16 19.6">
                    <g id="0bae9d9a-140a-49cb-a601-bca65bb59507" data-name="Layer 2">
                        <g id="de94d589-3cdd-4887-9ead-cc0a840c52cd" data-name="Layer 1">
                            <path d="M12.54,19.6a7.41,7.41,0,0,1-1-.06.5.5,0,0,1-.44-.55.5.5,0,0,1,.55-.44c1.21.13,3.37.11,4.26-1.53a1.92,1.92,0,0,0,.23-1.13c-.15-1.06-1.35-1.67-2-2-.47-.24-1.9-1-2.78-.45a1,1,0,0,0-.4.46,1.18,1.18,0,0,1-.71.67c-1.62.45-3.43-.89-4.51-2.41S4,8.4,5.17,6.67a1.83,1.83,0,0,1,.57-.53,1,1,0,0,0,.41-.44c.31-.65.12-1.59-.55-2.78S4.23,1.09,3.51,1a1.9,1.9,0,0,0-1.11.27C1.35,1.91.85,3.83,1,6.55c.29,4.23,3.35,9.85,7.79,11.55a.5.5,0,1,1-.36.93C3.6,17.17.36,11.25,0,6.62-.18,3.46.48,1.27,1.89.42A2.87,2.87,0,0,1,3.62,0c1.06.12,2,.93,2.85,2.42s1,2.72.59,3.69A2,2,0,0,1,6.3,7,1.07,1.07,0,0,0,6,7.24c-.91,1.31-.29,3.1.59,4.34,1,1.44,2.45,2.3,3.41,2a.71.71,0,0,0,.11-.17,1.94,1.94,0,0,1,.77-.85c1.36-.79,3.09.08,3.74.42s2.32,1.18,2.54,2.75a3,3,0,0,1-.34,1.75A4.57,4.57,0,0,1,12.54,19.6Z"/>
                        </g>
                    </g>
                </svg>
                <p class="ml-8 font-light">06 30 / 260 3004</p>
            </div>
            <div class="my-4 flex justify-start items-center">
                <svg class="w-6 h-6 p-px svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
                    <g id="1fe1786d-063e-4f82-91b5-06aca0367829" data-name="Layer 2">
                        <g id="2076dfee-ca81-4b54-9516-fd0b92b27137" data-name="Layer 1">
                            <path d="M6,10.5A4.51,4.51,0,0,0,10.5,15a3.48,3.48,0,0,0,2.75-1.27,3.68,3.68,0,0,0,.83-2.15,3.63,3.63,0,0,0-.07-1,.28.28,0,0,1,0-.09h0a.41.41,0,0,1,0-.16.8.8,0,0,1,.08-.16l.11-.1h0A.38.38,0,0,1,14.4,10h.1a.45.45,0,0,1,.16,0h0l.12.07.1.11v0a.44.44,0,0,1,.06.16.31.31,0,0,1,0,.1,4,4,0,0,1,.08.91c.16,1.06.7,2.59,2.42,2.59,1.07,0,2.5-1.73,2.5-3.5A9.5,9.5,0,1,0,10.5,20c3,0,5.28-.72,6.89-2.15a.5.5,0,1,1,.66.75c-1.8,1.59-4.34,2.4-7.55,2.4A10.5,10.5,0,1,1,21,10.5c0,2.23-1.77,4.5-3.5,4.5a3.08,3.08,0,0,1-2.83-1.67,4.79,4.79,0,0,1-.64,1A4.47,4.47,0,0,1,10.5,16a5.5,5.5,0,0,1,0-11,4.09,4.09,0,0,1,3.9,2.46.49.49,0,0,1-.24.66.5.5,0,0,1-.67-.24A3.05,3.05,0,0,0,10.5,6,4.51,4.51,0,0,0,6,10.5Z"/>
                        </g>
                    </g>
                </svg>
                <p class="ml-8 font-light">hello@visualz.hu</p>
            </div>
            <div class="md:my-4">
                <span class="">Levelezési címünk:</span>
                <p class="">1096 Budapest, Lenhossék utca 3. A. lph. 1. em. 1.</p>
            </div>
            <div class="my-4">
                <span class="">Designerünkkel vennéd fel a
                    kapcsolatot?</span>
                <p class="">Megteheted: dorka@visualz.hu</p>
            </div>
            <div class="md:my-4">
                <span class="">Esetleg a fejlesztőnkkel?</span>
                <p class="">Őt itt éred el: gabor@visualz.hu</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ContactInfo'
}
</script>

<style scoped>
    .rotate {
        transform: rotate(-90deg);
    }

    .svg {
        stroke: white;
        color: white;
        fill: currentColor;
    }
</style>



// WEBPACK FOOTER //
// src/components/ContactInfo.vue